// A denial from one Twin (or its IS) does not invalidate the TwinScope session.
// Only the authoritative AAA endpoint can establish loss of supervisor access.
export async function supervisorAccessLost(error, { signal, fetcher = fetch } = {}) {
  if (![401, 403].includes(error?.status) || signal?.aborted) return false;
  try {
    const response = await fetcher('/api/aaa/context', {
      cache: 'no-store', signal: signal ? AbortSignal.any([signal, AbortSignal.timeout(10000)]) : AbortSignal.timeout(10000),
      headers: { accept: 'application/json' },
    });
    if (signal?.aborted) return false;
    if ([401, 403].includes(response.status)) return true;
    if (!response.ok) return false; // An outage is not evidence of revoked access.
    const access = await response.json();
    if (signal?.aborted) return false;
    if (!access?.subject?.did || !Array.isArray(access.permissions)) return false;
    return !access.permissions.includes('tenant:admin');
  } catch { return false; }
}
